import { render, staticRenderFns } from "./handwriting.vue?vue&type=template&id=09f74630&scoped=true&"
import script from "./handwriting.vue?vue&type=script&lang=js&"
export * from "./handwriting.vue?vue&type=script&lang=js&"
import style0 from "./handwriting.vue?vue&type=style&index=0&id=09f74630&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f74630",
  null
  
)

export default component.exports